import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LNG_STORAGE_KEY, RouterInterceptorService } from './common/service/router-interceptor.service';
import { CheckForUpdateService } from '@damofire/uix-commons';
import { WarehouseInterceptorService } from '@damofire/data-watson';
import { StorageService } from '@damofire/data-angular-commons';
import { environment } from '../environments/environment';
import { UserActionsService } from '@damofire/data-stas';
import { AppAuthService } from './security/app-auth.service';
import { catchError, finalize, take, timeout } from 'rxjs/operators';
import { of } from 'rxjs';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent {
  constructor(
    private readonly routerInterceptor: RouterInterceptorService,
    private readonly wRouterInterceptor: WarehouseInterceptorService,
    private readonly userActionsService: UserActionsService,
    private readonly translate: TranslateService,
    private readonly storageService: StorageService,
    private readonly checkForUpdateService: CheckForUpdateService,
    private readonly appAuthService: AppAuthService,
  ) {
    this.initLanguage();
    if (environment.target === 'hosting') {
      checkForUpdateService.init();
      this.listenOnUserReady().catch(console.error);
    } else {
      this.removeLoading();
    }
  }

  private initLanguage(): void {
    let currentLng = this.translate.currentLang;
    if (!currentLng) {
      currentLng = this.storageService.getItem(LNG_STORAGE_KEY);

      if (!currentLng) {
        currentLng = this.translate.getBrowserLang();

        if (!['fr', 'en'].includes(currentLng)) {
          currentLng = this.translate.getFallbackLang();
        }
      }

      this.translate.use(currentLng);
    }
  }

  private async listenOnUserReady(): Promise<void> {
    if (await this.appAuthService.isAuthenticated()) {
      this.appAuthService
        .onUserReady()
        .pipe(
          timeout({ first: 10000 }),
          finalize(this.removeLoading),
          take(1),
          catchError(async () => {
            console.log('listenOnUserReady timeout');
            return of(true);
          }),
        )
        .subscribe();
    } else {
      this.removeLoading();
    }
  }

  private removeLoading(): void {
    // Couldn't find a better way to remove the loading from index.html
    document.getElementById('initial-loading')?.remove();
  }
}
